<template>
  <div style="width: 100%">
    <vxe-table border auto-resize resizable show-overflow keep-source :data="tableData">
      <template #empty>
        <p style="margin-top: 60px">没有更多数据了！</p>
      </template>
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) of tableColumn"
        :key="index"
        :field="item.field"
        :title="item.title"
        :edit-render="item.itemRender"
        :minWidth="item.width"
      >
        <template v-slot="{ row }">
          <template v-if="item.field === 'approvalStatus'">{{
            row.approvalStatus == '01' ? '通过' : '驳回'
          }}</template>
          <template v-else>{{ row[item.field] }}</template>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  export default {
    name: 'ApprovalRecordTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableColumn: [
          {
            title: '审批时间',
            field: 'approvalDate',
          },

          {
            title: '审批人',
            field: 'approvalPersonName',
          },
          {
            title: '部门',
            field: 'departmentName',
          },
          {
            title: '反馈意见',
            field: 'approvalComment',
          },
          {
            title: '审批状态',
            field: 'approvalStatus',
          },
        ],
        tableData: [],
      };
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.tableData = val;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
